// extracted by mini-css-extract-plugin
export default {"timeInput":"MTpRr"};